import { formatDateForDisplay } from "../../utils/displayDateFormat";

/**
 * Renders a date as DD/MM/YYYY for lists/cards. Does not alter stored/API values.
 */
const DisplayDate = ({ value, emptyLabel = "-" }) => {
  if (value == null || value === "") return emptyLabel;
  const formatted = formatDateForDisplay(value);
  return formatted || emptyLabel;
};

export default DisplayDate;
